import { Link } from "react-router-dom";
import { Slogan } from "./Slogan";
export const Logo = ({ light = false, tagline = false, testId = "brand-logo" }) => (
  <Link to="/" data-testid={testId} className="group flex items-center gap-2 shrink-0" aria-label="ShopaBee home">
    <svg width="34" height="34" viewBox="0 0 36 36" aria-hidden="true" className="transition-transform duration-300 group-hover:-rotate-12">
      <ellipse cx="11" cy="11" rx="6" ry="4.5" fill="#BFE3FF" transform="rotate(-30 11 11)" />
      <ellipse cx="25" cy="11" rx="6" ry="4.5" fill="#BFE3FF" transform="rotate(30 25 11)" />
      <ellipse cx="18" cy="21" rx="10" ry="9" fill="#E2A100" />
      <path d="M11 18.5h14M10 23h16" stroke="#202A35" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
    <span className="flex flex-col">
      <span className="font-display text-[1.6rem] font-bold tracking-tight leading-none">
        <span className={light ? "text-white" : "text-[#202A35]"}>Shopa</span>
        <span className="text-[#E2A100]">Bee</span>
      </span>
      {tagline && <span data-testid="brand-tagline" className={`hidden sm:block text-[10.5px] font-semibold mt-0.5 ${light ? "text-white/60" : "text-[#202A35]/55"}`}><Slogan tone={light ? "light" : "default"} /></span>}
    </span>
  </Link>
);
